// This is not an arbitrary value.  It acts as a wildcard for the automation rules.
export const ANY_PACKAGE_REGEX = '*';
export const NO_SELECTION = '';
